/**
 * Bögrebolt: szállítási mód választó a kosárban.
 * A vásárlónak a kosárban kell választania: Foxpost automata vagy Házhozszállítás.
 * Amíg nincs érvényes választás, a Fizetés gomb nem enged tovább.
 * Foxpost automatánál csak akkor, ha a PickupBird térképen ki is választott egy automatát.
 * Markup + CSS: snippets/bogrebolt-delivery-choice.liquid
 */
(function () {
  if (window.__bbDeliveryChoice) return;
  window.__bbDeliveryChoice = true;

  var ATTR = 'Szállítási mód';
  var LABEL = { automata: 'Foxpost automata', home: 'Házhozszállítás' };
  var DEFAULT_HIDDEN_RATES = 'Foxpost csomagautomata utánvéttel|Foxpost csomagautomata';
  var MSG_NONE = 'Válaszd ki, hogyan kéred a bögréket.';
  var MSG_POINT = 'Válassz Foxpost automatát a térképen.';
  var MSG_NOMAP = 'A térkép még nem töltött be. Várj egy pillanatot, vagy frissítsd az oldalt.';
  var PB_KEYS = ['Shipping type', 'Shipping rate name', 'Hidden shipping rates', 'Payment Methods', 'Pickup point', 'Shop address', 'Package point ID', 'Operator ID'];
  var BASELINE_KEY = 'bbDcHomeBaseline';

  var root = document.documentElement;
  var state = {
    mode: root.getAttribute('data-bb-dc-mode') || '',
    point: root.getAttribute('data-bb-dc-point') === '1',
    count: Number(root.getAttribute('data-bb-dc-count') || 0),
  };
  var pending = null; // Promise while we change the mode
  var lastError = '';

  /* ---------- telefonszám ---------- */
  var PHONE_ATTR = 'Telefonszám';
  var MOBILE = ['20', '30', '31', '50', '70'];

  // Bármilyen magyar alakból +36XXXXXXXXX lesz, érvénytelennél ''.
  function normalizePhone(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.indexOf('0036') === 0) d = d.slice(4);
    else if (d.indexOf('36') === 0 && d.length >= 10) d = d.slice(2);
    else if (d.indexOf('06') === 0) d = d.slice(2);
    if (d.length === 9) return MOBILE.indexOf(d.slice(0, 2)) !== -1 ? '+36' + d : '';
    if (d.length === 8 && d.charAt(0) !== '0' && MOBILE.indexOf(d.slice(0, 2)) === -1) return '+36' + d;
    return '';
  }

  function formatPhone(n) {
    if (!n) return '';
    var d = n.slice(3);
    if (d.length === 9) return '+36 ' + d.slice(0, 2) + ' ' + d.slice(2, 5) + ' ' + d.slice(5);
    if (d.charAt(0) === '1') return '+36 1 ' + d.slice(1, 4) + ' ' + d.slice(4);
    return '+36 ' + d.slice(0, 2) + ' ' + d.slice(2, 5) + ' ' + d.slice(5);
  }

  var phoneSaved = normalizePhone(root.getAttribute('data-bb-dc-phone'));
  var phoneState = { value: phoneSaved, showError: false };
  var phoneSaving = null;

  function phoneInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-bb-dc-phone]'));
  }

  function savePhone(n) {
    if (n === phoneSaved) return Promise.resolve();
    var attrs = {};
    attrs[PHONE_ATTR] = n;
    var p = cartFetch('/cart/update.js', { attributes: attrs }).then(function (c) {
      if (c && c.attributes) phoneSaved = normalizePhone(c.attributes[PHONE_ATTR]);
    }).catch(function () {});
    phoneSaving = p;
    p.then(function () { if (phoneSaving === p) phoneSaving = null; });
    return p;
  }

  function onPhoneInput(el, commit) {
    var n = normalizePhone(el.value);
    phoneState.value = n;
    if (commit) {
      phoneState.showError = !n;
      if (n) {
        el.value = formatPhone(n);
        savePhone(n);
      } else if (phoneSaved && !el.value.trim()) {
        savePhone('');
      }
    } else if (n) {
      phoneState.showError = false;
    }
    phoneInputs().forEach(function (i) { if (i !== el) i.value = el.value; });
    render();
  }

  function renderPhone(b) {
    var wrap = b.querySelector('[data-bb-dc-phone-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-bb-dc-phone]');
    if (input && document.activeElement !== input && phoneState.value && normalizePhone(input.value) !== phoneState.value) {
      input.value = formatPhone(phoneState.value);
    }
    var err = wrap.querySelector('.bb-dc__phone-error');
    wrap.classList.toggle('bb-dc__phone--invalid', phoneState.showError);
    if (input) input.setAttribute('aria-invalid', phoneState.showError ? 'true' : 'false');
    if (err) err.hidden = !phoneState.showError;
  }

  function phoneValid() { return !!phoneState.value; }

  function isValid() { return deliveryValid() && phoneValid(); }

  function deliveryValid() {
    if (state.mode === 'home') return !state.point;
    if (state.mode === 'automata') return state.point;
    return false;
  }

  function hasPointAttrs(a) {
    a = a || {};
    return !!(a['Pickup point'] || a['Shipping type'] || a['Package point ID']);
  }

  function storedPlace() {
    try {
      var v = JSON.parse(sessionStorage.getItem('chosenPlace') || 'null');
      return v && v.name ? v : null;
    } catch (e) {
      return null;
    }
  }

  /* ---------- DOM ---------- */

  function blocks() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-bb-dc]'));
  }

  function render() {
    root.setAttribute('data-bb-dc-mode', state.mode);
    root.setAttribute('data-bb-dc-point', state.point ? '1' : '0');
    root.setAttribute('data-bb-dc-valid', isValid() ? '1' : '0');
    if (deliveryValid()) lastError = '';
    blocks().forEach(function (b) {
      b.setAttribute('data-mode', state.mode);
      Array.prototype.forEach.call(b.querySelectorAll('input[type="radio"]'), function (i) {
        var want = i.value === state.mode;
        if (i.checked !== want) i.checked = want;
      });
      renderPhone(b);
      if (typeof notes !== 'undefined' && notes) {
        var ci = b.querySelector('[data-bb-dc-courier]'), oi = b.querySelector('[data-bb-dc-ordernote]');
        if (ci && notes.courier !== null && ci !== document.activeElement && ci.value !== notes.courier) ci.value = notes.courier;
        if (oi && notes.order !== null && oi !== document.activeElement && oi.value !== notes.order) oi.value = notes.order;
      }
      var err = b.querySelector('.bb-dc__error:not(.bb-dc__phone-error)');
      if (err) {
        if (lastError) {
          if (err.textContent !== lastError) err.textContent = lastError;
          err.hidden = false;
        } else if (!err.hidden) {
          err.hidden = true;
          err.textContent = '';
        }
      }
      if (!lastError) b.classList.remove('bb-dc--alert');
    });
  }

  function blockNear(el) {
    var scope = el && el.closest && el.closest('.cart-drawer__summary, .cart-summary__inner, #cart-drawer, .cart-page, main');
    var b = scope && scope.querySelector('[data-bb-dc]');
    if (b) return b;
    var all = blocks().filter(function (x) { return x.offsetParent !== null; });
    return all[0] || blocks()[0] || null;
  }

  function showError(msg, near) {
    lastError = msg;
    render();
    var b = blockNear(near);
    if (!b) return;
    b.classList.add('bb-dc--alert');
    b.classList.remove('bb-dc--flash');
    void b.offsetWidth;
    b.classList.add('bb-dc--flash');
    setTimeout(function () { b.classList.remove('bb-dc--flash'); }, 1600);
    try { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { b.scrollIntoView(); }
  }

  function pbContainer() {
    return document.querySelector('#mapApp .pp-provider-selector-container');
  }

  function openMap() {
    var c = pbContainer();
    if (!c) return false;
    var btn = c.querySelector('.pp-provider-selector-spacedout-cart-button, .pp-provider-selector-center-cart-button, .pp-provider-selector-only-cart-button, button');
    if (!btn) {
      var pencil = c.querySelector('.polaris-icon-wrapper > :first-child svg, .polaris-icon-wrapper > :first-child');
      btn = pencil;
    }
    if (!btn) return false;
    btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    return true;
  }

  /* ---------- cart ---------- */

  function rememberBaseline(a) {
    // Values PickupBird writes when no point is selected (used only as fallback).
    if (!a || hasPointAttrs(a) || !a['Hidden shipping rates']) return;
    try {
      localStorage.setItem(BASELINE_KEY, JSON.stringify({ hidden: a['Hidden shipping rates'], pm: a['Payment Methods'] || '' }));
    } catch (e) {}
  }

  function baseline() {
    try {
      var b = JSON.parse(localStorage.getItem(BASELINE_KEY) || 'null');
      if (b && b.hidden) return b;
    } catch (e) {}
    return { hidden: DEFAULT_HIDDEN_RATES, pm: '' };
  }

  function applyCart(cart) {
    if (!cart || typeof cart !== 'object' || !('attributes' in cart)) return;
    var a = cart.attributes || {};
    state.count = Number(cart.item_count || 0);
    root.setAttribute('data-bb-dc-count', String(state.count));
    state.point = hasPointAttrs(a);
    rememberBaseline(a);
    bbSyncNotes(a[COURIER_ATTR] || '', cart.note || '');
    phoneSaved = normalizePhone(a[PHONE_ATTR]);
    var focused = document.activeElement && document.activeElement.hasAttribute && document.activeElement.hasAttribute('data-bb-dc-phone');
    if (!focused && !phoneSaving && phoneSaved) phoneState.value = phoneSaved;
    if (!pending) {
      var saved = a[ATTR] === LABEL.automata ? 'automata' : a[ATTR] === LABEL.home ? 'home' : '';
      var mode = state.point ? 'automata' : saved || state.mode;
      // A kiválasztott automata mindig automata módot jelent.
      if (mode !== state.mode) state.mode = mode;
      if (state.count > 0 && mode && a[ATTR] !== LABEL[mode]) saveMode(mode);
    }
    render();
  }

  var nativeFetch = window.fetch;

  function cartFetch(url, body) {
    return nativeFetch.call(window, url, body ? {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    } : { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return cartFetch('/cart.js').then(function (c) { applyCart(c); return c; }).catch(function () {});
  }

  var saving = null;
  function saveMode(mode) {
    var attrs = {};
    attrs[ATTR] = LABEL[mode] || '';
    if (mode !== 'home') attrs['Megjegyzés a futárnak'] = '';
    else if (notes.courier !== null || noteInputs('courier').length) attrs['Megjegyzés a futárnak'] = String(noteValue('courier') || '').trim();
    saving = cartFetch('/cart/update.js', { attributes: attrs }).catch(function () {});
    return saving;
  }

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function resetCartFormAction() {
    var f = document.querySelector('form#cart-form');
    if (f && /shipping_address/.test(f.getAttribute('action') || '')) {
      f.setAttribute('action', '/cart?step=contact_information&checkout[shipping_address][address1]=&checkout[shipping_address][city]=&checkout[shipping_address][zip]=&checkout[shipping_address][country]=');
    }
  }

  // Kiválasztott automata törlése: először a PickupBird saját törlés gombjával,
  // ha az nem megy, kézzel ugyanazokra az értékekre állítjuk, amit a PickupBird ír.
  function removePoint() {
    var trash = document.querySelector('#mapApp .polaris-icon-wrapper > :nth-child(2) svg') ||
      document.querySelector('#mapApp .polaris-icon-wrapper > :nth-child(2)');
    if (trash) trash.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    var tries = 0;
    function poll() {
      return sleep(400).then(function () {
        return cartFetch('/cart.js');
      }).then(function (c) {
        var cleared = !hasPointAttrs(c.attributes) && !storedPlace();
        if (cleared) return c;
        tries++;
        if (tries < (trash ? 10 : 1)) return poll();
        try { sessionStorage.removeItem('chosenPlace'); } catch (e) {}
        var b = baseline();
        var attrs = {};
        PB_KEYS.forEach(function (k) { attrs[k] = ''; });
        attrs['Hidden shipping rates'] = b.hidden;
        attrs['Payment Methods'] = b.pm;
        return cartFetch('/cart/update.js', { attributes: attrs });
      });
    }
    return poll().then(function (c) {
      resetCartFormAction();
      return c;
    }).catch(function () {});
  }

  function setMode(mode, opts) {
    if (mode !== 'automata' && mode !== 'home') return;
    opts = opts || {};
    state.mode = mode;
    lastError = '';
    render();
    var job;
    if (mode === 'home') {
      var needsRemove = state.point || !!storedPlace();
      job = (needsRemove ? removePoint() : Promise.resolve()).then(function () {
        return saveMode('home');
      });
    } else {
      job = saveMode('automata');
      if (!state.point && opts.openMap) setTimeout(openMap, 150);
    }
    var p = job.then(function (c) {
      if (pending === p) pending = null;
      if (c && c.attributes) applyCart(c);
      else return refreshCart();
    }, function () { if (pending === p) pending = null; });
    pending = p;
    return p;
  }

  /* ---------- watch cart requests (PickupBird, theme) ---------- */

  function pathOf(input) {
    try { return new URL(typeof input === 'string' ? input : input.url, location.origin).pathname; } catch (e) { return ''; }
  }

  var wrappedFetch = window.fetch;
  window.fetch = function (input, init) {
    var res = wrappedFetch.apply(this, arguments);
    var path = pathOf(input);
    if (/\/cart(\.js|\/update(\.js)?|\/change(\.js)?|\/clear(\.js)?)$/.test(path)) {
      res.then(function (r) {
        if (!r || !r.ok) return;
        r.clone().json().then(function (c) {
          if (c && c.attributes) applyCart(c);
        }).catch(function () {});
      }).catch(function () {});
    }
    return res;
  };

  /* ---------- megjegyzések ---------- */
  var COURIER_ATTR = 'Megjegyzés a futárnak';
  var notes = { courier: null, order: null };
  var noteTimers = {};
  var noteSaving = null;

  // A mentett értékek visszatöltése (oldalfrissítés, kosár újrarajzolás után).
  function bbSyncNotes(courier, order) {
    var act = document.activeElement;
    [['courier', courier], ['order', order]].forEach(function (p) {
      var kind = p[0];
      if (noteTimers[kind] || noteSaving) return;
      if (state.mode !== 'home' && kind === 'courier' && !p[1]) return;
      notes[kind] = p[1];
      noteInputs(kind).forEach(function (i) { if (i !== act && i.value !== p[1]) i.value = p[1]; });
    });
  }

  function noteInputs(kind) {
    return Array.prototype.slice.call(document.querySelectorAll(kind === 'courier' ? '[data-bb-dc-courier]' : '[data-bb-dc-ordernote]'));
  }

  function noteValue(kind) {
    if (notes[kind] !== null) return notes[kind];
    var i = noteInputs(kind)[0];
    return i ? i.value : '';
  }

  function saveNote(kind) {
    clearTimeout(noteTimers[kind]);
    var v = String(noteValue(kind) || '').trim();
    var body;
    if (kind === 'courier') {
      var a = {};
      a[COURIER_ATTR] = state.mode === 'home' ? v : '';
      body = { attributes: a };
    } else {
      body = { note: v };
    }
    var p = cartFetch('/cart/update.js', body).catch(function () {});
    noteSaving = p;
    p.then(function () { if (noteSaving === p) noteSaving = null; });
    return p;
  }

  function onNoteInput(el, commit) {
    var kind = el.hasAttribute('data-bb-dc-courier') ? 'courier' : 'order';
    notes[kind] = el.value;
    noteInputs(kind).forEach(function (i) { if (i !== el) i.value = el.value; });
    clearTimeout(noteTimers[kind]);
    if (commit) saveNote(kind);
    else noteTimers[kind] = setTimeout(function () { saveNote(kind); }, 700);
  }

  function flushNotes() {
    var jobs = [];
    ['courier', 'order'].forEach(function (k) {
      if (noteTimers[k]) { clearTimeout(noteTimers[k]); noteTimers[k] = null; jobs.push(saveNote(k)); }
    });
    if (noteSaving) jobs.push(noteSaving);
    return jobs.length ? Promise.all(jobs) : null;
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && (t.hasAttribute('data-bb-dc-courier') || t.hasAttribute('data-bb-dc-ordernote'))) onNoteInput(t, false);
  });
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && (t.hasAttribute('data-bb-dc-courier') || t.hasAttribute('data-bb-dc-ordernote'))) onNoteInput(t, true);
  });

  /* ---------- events ---------- */

  // Telefonszám előtöltése a pénztárban (ha a Shopify figyelembe veszi).
  function addPhoneToCheckout() {
    var f = document.querySelector('form#cart-form');
    if (!f || !phoneState.value) return;
    var act = f.getAttribute('action') || '/cart';
    act = act.replace(/[?&]checkout\[shipping_address\]\[phone\]=[^&]*/g, '').replace(/[?&]checkout\[phone\]=[^&]*/g, '');
    var enc = encodeURIComponent(phoneState.value);
    act += (act.indexOf('?') === -1 ? '?' : '&') + 'checkout[shipping_address][phone]=' + enc;
    f.setAttribute('action', act);
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-bb-dc-phone')) onPhoneInput(t, false);
  });
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-bb-dc-phone')) onPhoneInput(t, true);
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t && t.hasAttribute && t.hasAttribute('data-bb-dc-phone')) {
      e.preventDefault();
      onPhoneInput(t, true);
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-bb-dc]') || t.type !== 'radio') return;
    setMode(t.value, { openMap: true });
  });

  // Az automata kártyára kattintva akkor is nyíljon a térkép, ha már ki volt jelölve.
  document.addEventListener('click', function (e) {
    var opt = e.target && e.target.closest && e.target.closest('[data-bb-dc-option="automata"]');
    if (opt && state.mode === 'automata' && !state.point && e.target.tagName !== 'INPUT') {
      setTimeout(openMap, 150);
    }
  });

  function checkoutTarget(el) {
    if (!el || !el.closest) return null;
    if (el.closest('#mapApp')) return null;
    return el.closest('button[name="checkout"], input[name="checkout"], .cart__checkout-button, a[href^="/checkout"], a[href*="/checkouts/"]');
  }

  function guard(e, btn) {
    if (state.count === 0 && !document.querySelector('[data-bb-dc]')) return;
    if (pending) {
      e.preventDefault();
      e.stopImmediatePropagation();
      pending.then(function () { btn.click(); });
      return;
    }
    var nf = flushNotes();
    if (nf) {
      e.preventDefault();
      e.stopImmediatePropagation();
      nf.then(function () { noteSaving = null; btn.click(); });
      return;
    }
    if (!phoneValid()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      phoneState.showError = true;
      render();
      var pb = blockNear(btn);
      var pi = pb && pb.querySelector('[data-bb-dc-phone]');
      if (pi) {
        try { pi.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) {}
        pi.focus();
      }
      return;
    }
    if (phoneSaving || phoneSaved !== phoneState.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      (phoneSaving || savePhone(phoneState.value)).then(function () {
        if (phoneSaved !== phoneState.value) phoneSaved = phoneState.value;
        btn.click();
      });
      return;
    }
    if (isValid()) { addPhoneToCheckout(); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!state.mode) {
      showError(MSG_NONE, btn);
      return;
    }
    if (state.mode === 'automata') {
      if (storedPlace()) {
        // A választás épp mentés alatt lehet: frissítjük a kosarat, és ha rendben, megyünk tovább.
        refreshCart().then(function () {
          if (isValid()) btn.click();
          else { showError(MSG_POINT, btn); openMap(); }
        });
        return;
      }
      if (!pbContainer()) { showError(MSG_NOMAP, btn); return; }
      showError(MSG_POINT, btn);
      setTimeout(openMap, 350);
      return;
    }
    // home + point: shouldn't happen, clean up and retry
    setMode('home').then(function () { if (isValid()) btn.click(); });
  }

  document.addEventListener('click', function (e) {
    var btn = checkoutTarget(e.target);
    if (btn) guard(e, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    var sub = e.submitter;
    var toCheckout = (sub && sub.name === 'checkout') || /^\/checkout/.test(pathOf((f && f.getAttribute && f.getAttribute('action')) || ''));
    if (toCheckout) guard(e, sub || f.querySelector('[name="checkout"]') || f);
  }, true);

  /* ---------- keep in sync after AJAX re-renders ---------- */

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      render();
    });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  render();
  if (state.count > 0) refreshCart();
})();
